__turbopack_context__.v({
  "className": "caveat_e568269a-module__sxEW8G__className",
});
